import axios from "axios";
import { ApiResponse } from "@/types";
import { ApplicationError } from "@/common/application-error";
import { config } from "@/config";

const axiosInstance = axios.create({
  baseURL: config.baseUrl,
  timeout: 60000
});

axiosInstance.interceptors.response.use(response => {
  if (response.status !== 200) {
    throw new ApplicationError("Что-то пошло не так");
  }

  if (response.data.errors) {
    const { code, description } = response.data.errors[0];
    throw new ApplicationError(description, code);
  }

  console.log(response);

  return response;
});

const http = {
  get(url: string, params = {}): Promise<ApiResponse> {
    return axiosInstance.get(url, { params }).then(res => res.data);
  },

  post(url: string, params = {}): Promise<ApiResponse> {
    return axiosInstance.post(url, params).then(res => res.data);
  }
};

export { http };
